import * as React from "react";
import {
  FaCalendar,
  FaHome,
  FaLock,
  FaRegFileWord,
  FaSign
} from "react-icons/fa";
import AdminPage from "../pages/admin";
import CalendarPage from "../pages/calendar";
import CustomersPage from "../pages/customers";
import { default as HomePage } from "../pages/home";
import InvitePage from "../pages/invite";
import JobPage from "../pages/job";
import JobsPage from "../pages/jobs";
import LoginPage from "../pages/login";
import OAuthPage from "../pages/oauth";
import OnboardingPage from "../pages/onboarding";
import InstagramAnalyticsAudiencePage from "../pages/instagram_analytics/audience";
import InstagramAnalyticsBestPostsPage from "../pages/instagram_analytics/best_posts";
import InstagramAnalyticsEngagementPage from "../pages/instagram_analytics/engagement";
import InstagramAnalyticsGrowthPage from "../pages/instagram_analytics/growth";
import InstagramAnalyticsMediaDetailsPage from "../pages/instagram_analytics/media_details";
import InstagramAnalyticsMediaPage from "../pages/instagram_analytics/media";
import InstagramAnalyticsOverviewPage from "../pages/instagram_analytics/overview";
import PerformanceAnalyticsPage from "../pages/performance_analytics";
import PolicyPage from "../pages/policy";
import PublicPage from "../pages/public";
import PublicJobPage from "../pages/public_job";
import RecoverPage from "../pages/recover";
import ReportsPage from "../pages/reports";
import RequestJobPage from "../pages/request_job";
import SettingsPage from "../pages/settings";
import SignupPage from "../pages/signup_v2";

export interface RouteProps {
  title: string;
  key: string;
  icon?: React.ReactNode;
  url: string;
  component: React.ReactNode;
  private?: boolean;
  menu?: boolean;
  layout?: boolean;
  condition?: (data: { user: any; role: any }) => boolean;
}
const routes: RouteProps[] = [
  {
    title: "Login",
    key: "login",
    icon: <FaLock />,
    url: "/login",
    component: <LoginPage />,
  },
  {
    title: "Cadastro",
    key: "signup",
    icon: <FaSign />,
    url: "/cadastrar",
    component: <SignupPage />,
  },
  {
    title: "Cadastro de cliente",
    key: "signup-customer",
    icon: <FaSign />,
    url: "/cadastrar/cliente",
    component: <SignupPage customer />,
  },
  {
    title: "Cadastro com cupom",
    key: "signup-coupon",
    icon: <FaSign />,
    url: "/cadastrar/:coupon",
    component: <SignupPage />,
  },
  {
    title: "Convite",
    key: "invite",
    url: "/convite/:key",
    component: <InvitePage />,
  },
  {
    title: "Recuperar senha",
    key: "recover",
    url: "/recuperacao/:key",
    component: <RecoverPage />,
  },
  {
    title: "Dashboard",
    key: "home",
    icon: <FaHome />,
    url: "/",
    menu: true,
    private: true,
    component: <HomePage />,
  },
  {
    title: "Onboarding",
    key: "home",
    icon: <FaHome />,
    url: "/bem-vindo",
    menu: false,
    private: false,
    component: <OnboardingPage />,
  },
  {
    title: "Jobs",
    key: "jobs",
    icon: <FaHome />,
    url: "/jobs",
    menu: true,
    private: true,
    component: <JobsPage />,
  },
  {
    title: "Calendário",
    key: "calendar",
    icon: <FaCalendar />,
    url: "/calendar",
    menu: true,
    private: true,
    component: <CalendarPage />,
  },
  // {
  //   title: "Jobs",
  //   key: "job-preview",
  //   url: "/jobs/:jobId/preview",
  //   menu: false,
  //   private: false,
  //   component: <JobPreviewPage />,
  // },
  {
    title: "Clientes",
    key: "customers",
    icon: <FaHome />,
    url: "/clientes",
    condition: ({ role }) =>{
      console.log(role);
      return role?.profile?.title === "Administrador"
    },
    menu: true,
    private: true,
    component: <CustomersPage />,
  },
  {
    title: "Clientes",
    key: "customers",
    icon: <FaHome />,
    url: "/clientes/:customerId",
    condition: ({ role }) => role?.profile?.title === "Administrador",
    menu: false,
    private: true,
    component: <CustomersPage />,
  },
  {
    title: "Configurações",
    key: "settings",
    icon: <FaHome />,
    url: "/configuracoes",
    menu: true,
    private: true,
    component: <SettingsPage />,
  },
  {
    title: "Relatórios",
    key: "reports",
    icon: <FaHome />,
    url: "/relatorios",
    condition: ({ role, user }) => role?.profile?.title === "Administrador",
    menu: true,
    private: true,
    component: <ReportsPage />,
  },
  {
    title: "Configurações da conta",
    key: "settings",
    icon: <FaHome />,
    url: "/checkout",
    menu: false,
    private: true,
    component: <SettingsPage fixed="checkout" />,
  },
  {
    title: "Job",
    key: "job",
    url: "/jobs/:jobId",
    condition: ({ role }) => !!role,
    menu: false,
    private: true,
    component: <JobPage />,
  },
  {
    title: "Solicitar Job",
    key: "request",
    url: "/solicitar",
    condition: ({ role }) => !role,
    menu: false,
    private: true,
    component: <RequestJobPage />,
  },
  {
    title: "Job",
    key: "public_job",
    url: "/j/:jobId",
    menu: false,
    private: false,
    component: <PublicJobPage />,
  },
  {
    title: "Share",
    key: "public",
    url: "/:key",
    menu: false,
    private: false,
    component: <PublicPage />,
  },
  {
    title: "Admin",
    key: "admin",
    url: "/admin-aprova-ai",
    condition: ({ user }) => !!user?.isAdmin,
    menu: true,
    private: true,
    component: <AdminPage />,
  },
  {
    title: "Política de Privacidade",
    key: "signup-company",
    icon: <FaRegFileWord />,
    url: "/politica-de-privacidade",
    component: <PolicyPage />,
  },
  {
    title: "OAuth",
    key: "oauth",
    url: "/oauth/:origin",
    component: <OAuthPage />,
  },
  {
    title: "Relatórios do Instagram",
    key: "instagram-analytics-overview",
    url: "/analytics/instagram/:oauthId",
    menu: false,
    private: true,
    component: <InstagramAnalyticsOverviewPage />,
  },
  {
    title: "Relatórios do Instagram - Mídias",
    key: "instagram-analytics-media",
    url: "/analytics/instagram/:oauthId/media",
    menu: false,
    private: true,
    component: <InstagramAnalyticsMediaPage />,
  },
  {
    title: "Relatórios do Instagram - Detalhes da mídia",
    key: "instagram-analytics-media-details",
    url: "/analytics/instagram/:oauthId/media/:mediaId",
    menu: false,
    private: true,
    component: <InstagramAnalyticsMediaDetailsPage />,
  },
  {
    title: "Relatórios do Instagram - Crescimento",
    key: "instagram-analytics-growth",
    url: "/analytics/instagram/:oauthId/growth",
    menu: false,
    private: true,
    component: <InstagramAnalyticsGrowthPage />,
  },
  {
    title: "Relatórios do Instagram - Engajamento",
    key: "instagram-analytics-engagement",
    url: "/analytics/instagram/:oauthId/engagement",
    menu: false,
    private: true,
    component: <InstagramAnalyticsEngagementPage />,
  },
  {
    title: "Relatórios do Instagram - Melhores posts",
    key: "instagram-analytics-best-posts",
    url: "/analytics/instagram/:oauthId/best-posts",
    menu: false,
    private: true,
    component: <InstagramAnalyticsBestPostsPage />,
  },
  {
    title: "Relatórios do Instagram - Audiência",
    key: "instagram-analytics-audience",
    url: "/analytics/instagram/:oauthId/audience",
    menu: false,
    private: true,
    component: <InstagramAnalyticsAudiencePage />,
  },
  {
    title: "Analytics de Performance",
    key: "performance-analytics",
    url: "/analytics/performance",
    menu: false,
    private: true,
    component: <PerformanceAnalyticsPage />,
  },
];

export default routes;
